<div class="tituloDialog">{{ titulo }}</div>
<div mat-dialog-content>
    <form class="formContainer" [formGroup]="formulario" (ngSubmit)="onSubmit()">
        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>PA - Ponto de Atendimento</mat-label>
                <mat-select #codPA formControlName="codPA">
                    <combo-search #searcher [itens]="agencias" [filtroCtrl]="filtroCtrl"></combo-search>
                    <mat-option *ngFor="let agencia of searcher.itensFiltrados | async" [value]="agencia.codPA">
                        {{ agencia.codPA }} - {{ agencia.cidade }}
                    </mat-option>
                </mat-select>

            </mat-form-field>
        </div>
        <footer class="item-right">
            <button mat-button class="btnOK mat-elevation-z8" type="submit" [disabled]="
          formulario.status === 'INVALID' ||
          formulario.pristine">Salvar</button>
            <button mat-button mat-dialog-close class="btnCancel mat-elevation-z8">Cancelar</button>
        </footer>
    </form>
</div>